// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + "sqlite-worker" + "." + "7d0dc9e459a1e89b" + ".js"
}